export const buildFieldName = (field, prefix) => {
  const fieldName = prefix ? `${prefix}.${field.name}` : field.name;
  return fieldName;
};
